import { createContext, useContext } from 'react';
import { WizardContext } from '..';

const context = createContext<WizardContext>({
  steps: [],
  register: () => {},
  update: () => {},
  onComplete: () => {},
  setActivePage: () => {},
  setActiveGroup: () => {},
  onLoad: () => {},
});

export const useWizard = () => {
  return useContext(context);
};

export default context;
